import { Species } from '@omniafishing/core';
import _ from 'lodash';
import React, { useEffect } from 'react';
import { ScrollToTop } from '../components/scroll_to_top/scroll_to_top';
import { SEO } from '../components/seo/seo';
import { SpeciesDetailContainer } from '../components/species_detail/species_detail_container';
import { useUserPreferences } from '../hooks/use_user_preferences';

interface SpeciesPageProps {
  selectedSpecies: Species;
}

export const SpeciesPage: React.FC<SpeciesPageProps> = (props) => {
  const { selectedSpecies } = props;
  const metaTitle = selectedSpecies.meta_title || _.startCase(selectedSpecies.display_name);
  const { setUserPreferencesSpecies } = useUserPreferences();

  useEffect(() => {
    setUserPreferencesSpecies(selectedSpecies.name);
  }, []);

  return (
    <ScrollToTop>
      <section>
        <SEO
          title={metaTitle}
          titleTemplate="%s"
          description={selectedSpecies.meta_description}
        ></SEO>
        <SpeciesDetailContainer selectedSpecies={selectedSpecies} />
      </section>
    </ScrollToTop>
  );
};

export default SpeciesPage;
